import { useState, useEffect } from "react";
import { X, CheckCircle, AlertCircle, Info } from "lucide-react";

export default function NotificationPopup({ type = "info", message, onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 4000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const getStyles = () => {
    switch (type) {
      case "success":
        return {
          bg: "bg-green-50",
          border: "border-green-200",
          text: "text-green-800",
          icon: "text-green-600",
          Icon: CheckCircle,
        };
      case "error":
        return {
          bg: "bg-red-50",
          border: "border-red-200",
          text: "text-red-800",
          icon: "text-red-600",
          Icon: AlertCircle,
        };
      case "info":
      default:
        return {
          bg: "bg-blue-50",
          border: "border-blue-200",
          text: "text-blue-800",
          icon: "text-blue-600",
          Icon: Info,
        };
    }
  };

  const styles = getStyles();
  const Icon = styles.Icon;

  return (
    <div
      className={`fixed top-4 right-4 max-w-md ${styles.bg} ${styles.border} border rounded-lg shadow-lg p-4 flex gap-3 items-start z-50 animate-slideIn`}
    >
      <Icon className={`w-5 h-5 ${styles.icon} flex-shrink-0 mt-0.5`} />
      <div className={`flex-1 ${styles.text} text-sm font-medium`}>
        {message}
      </div>
      <button
        onClick={onClose}
        className={`${styles.icon} hover:opacity-75 transition flex-shrink-0`}
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}
